export default "__VITE_ASSET__0b1882b2__"